import { get } from '@/utils'
export default {
  computed: {
    gridDataLoading () {
      return get(this.$refs, 'grid.$refs.tableWrapper.loadingStateValue')
    },
    // filtersCount () {
    //   return get(this.$refs, 'grid.$refs.tableWrapper.filtersCount', 0)
    // },
    resultsCount () {
      return get(this.$refs, 'grid.$refs.tableWrapper.totalRows', 0)
    }
  }
}
